Ext.define('SA.view.CenteredModal', {
    alias: 'widget.centered-modal',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    floating: true,
    modal: true,

    initComponent() {
        var {cls, items} = this;

        this.items = [{xtype: 'simple-container', cls, items}];

        this.removeCls(cls).addCls('sa-centered-modal');

        this.callParent();
    }
});